import { sr } from "../../../../date-fns/locale/sr.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    sr
  }
};